import { TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE } from '../shared/abstract-boxes';

export function WaitForMessageBoxViewConstructor(services, callbacks, context) {

  let joint = services.joint;
  let companyId = context.companyId;
  let site = context.site;
  let scenarioId = context.scenarioId;

  return joint.shapes.html.AbstractBoxElementWithDragAndDropView.extend({

    template: '<div class="html-element"></div>',


    initialize: function () {

      joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);

      this.updateBox();
    },

    resizeBox: function resizeBox() {
      this.resizeQuestionBox();
    },


    resizeQuestionBox: function resizeQuestionBox() {
      const question = this.model;
      const embeddedCells = question.getEmbeddedCells();

      const $addAnswer = this.$box.find('.add-answer');

      const paddingBottom = $addAnswer.outerHeight();
      const paddingTop = this.paddingTop();

      //Reposition and resize every answer
      let ypos = paddingTop;
      for (let answerOrNext of embeddedCells) {
        const answerOrNextView = this.paper.findViewByModel(answerOrNext);
        answerOrNext.position(0, ypos, { parentRelative: true });

        const answerOrNextHeight = answerOrNextView.$box.outerHeight();
        answerOrNext.resize(question.attributes.size.width, answerOrNextHeight);
        ypos += answerOrNextHeight;
      }

      question.fitEmbeds({ padding: { top: paddingTop, right: 0, bottom: paddingBottom, left: 0 } });

      //resize paper height if necessary
      callbacks.resizePaper();
    },

    getSpecialInputAnswerId: function getSpecialInputAnswerId(inputTypeName) {
      // Loop on all children and look if one is of "inputTypeName" type
      let question = this.model;
      let children = question.getEmbeddedCells();
      for (let answer of children) {
        if (answer.attributes.answerType === inputTypeName) {
          return answer.attributes.id;
        }
      }
      return 0;
    },

    saveSpecialInputId: function saveSpecialInputId(inputTypeName, inputGraphName) {
      let special_input_answer_id = this.getSpecialInputAnswerId(inputTypeName);
      this.model.set(inputGraphName, special_input_answer_id);
    },

    //Create an answer element with given id
    createAnswer: function (id,
      position = TMP_ELEMENT_POSITION,
      size = TMP_ELEMENT_SIZE,
      label = '',
      description = '',
      answerType = 'user-input',
      hasHandover = false) {

      let answer = new joint.shapes.html.UserInputAnswer({
        label: label,
        description: description,
        id: id,
        position: position,
        size: size,
        answerType,
        hasHandover: hasHandover,
      });

      this.model.embed(answer);

      return answer;
    },

    //Add a new answer with a new id; called on a add button click.
    addAnswer: function (label, answerType, editable) {
      services.QuickRepliesFactory.createUniqueId(companyId, site.id, scenarioId)
        .then(response => {
          let answer = this.createAnswer(response.data.id, undefined, undefined, label, undefined, answerType, undefined, undefined, undefined, undefined, undefined, editable, undefined, undefined);
          this.model.graph.addCell(answer);
          this.reorderChildren();
          this.resizeQuestionBox();
        },
          services.AlertingFactory.httpErrorHandler());
    },
  });
}
